// Libs
import React, { useState } from 'react'
import { Tooltip, Modal } from 'antd'
import { useRecoilState, useRecoilValue } from 'recoil'

// Own Libs
import { Button, FormContext, FormSubmitButton, MasterDetailForm, Row } from '@digital/ui'

//Api
import { aprovarCES, ISasPropostaOrdemCompra } from '@app/api/sas/sasProposta'

//Files
import { ordemCompraIdState, reloadVendorListState } from '../atoms'
import { UploadFile, Visibility } from '@app/components'

//Utils
import { vtObjToFormData } from '@app/helpers/objHelper'

interface Props {
    sasProposta: ISasPropostaOrdemCompra
}

export const ModalAprovarCES = () => {

    const [reloadVendorList, setReloadVendorList] = useRecoilState(reloadVendorListState);
    const ordemCompraId = useRecoilValue(ordemCompraIdState);

    const [exibirModal, setExibirModal] = useState(false);

    const handleCancel = () => {
        setExibirModal(false)
    }

    const handleSubmit = (values: any) => {
        const form = vtObjToFormData(values);
        form.append("ordemCompraId", ordemCompraId);

        aprovarCES(form)
            .then((data: any) => {
                if (data && data.valid) {
                    setReloadVendorList(!reloadVendorList);
                    handleCancel()
                }
            });

    }

    return (
        <>
            <Tooltip title="Aprovar CES">
                <Button icon='commons-ok' onClick={() => setExibirModal(true)}>
                    Aprovar CES
                </Button>
            </Tooltip>
            <Modal title={`Aprovar CES`} visible={exibirModal} onCancel={handleCancel} footer={null} >
                <Visibility visible={exibirModal} >
                    <MasterDetailForm
                        key={`form_ModalDispensarSolicitacaoChancelaGJMinuta_${ordemCompraId}`}
                        actions={[
                            <Button title='fechar' type='link' onClick={() => handleCancel()} />,
                            <FormSubmitButton title='Salvar' type='primary' noIcon onClick={handleSubmit} />
                        ]}
                    >
                        <FormContext.Consumer>
                            {({ formProps }) => (
                                <>

                                    <Row>

                                        <UploadFile
                                            idDoComponente='arquivo-ModalDispensarSolicitacaoChancelaGJMinuta'
                                            type='primary'
                                            hasFile={false}
                                            hasLabel={true}
                                            icon='ui-upload'
                                            span={6}
                                        />
                                        {/* {sasProposta.anexoConfirmarSolicitacaoChancelaGJMinuta && (
                                                <Button
                                                    icon='ui-download'
                                                    type='primary'
                                                    onClick={() => downloadArquivo(sasProposta.anexoConfirmarSolicitacaoChancelaGJMinuta.id, sasProposta.anexoConfirmarSolicitacaoChancelaGJMinuta.nome)}
                                                />
                                            )} */}
                                    </Row>
                                </>
                            )}
                        </FormContext.Consumer>

                    </MasterDetailForm>
                </Visibility>
            </Modal>
        </>
    )
}